import { onContentReady } from "@story/story_assets/utils";

import Hls from "hls.js";
import Plyr from "plyr";

let players = new WeakMap();
let hlss = new WeakMap();

function estimateBandwidth() {
	const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
	let abrEstimate = 4000000; // fallback ~4 Mbps

	if (connection) {
		if (connection.saveData) {
			abrEstimate = 500000; // 1 Mbps for data-saver mode
		} else {
			switch (connection.effectiveType) {
				case "slow-2g":
					abrEstimate = 300000;
					break;
				case "2g":
					abrEstimate = 500000;
					break;
				case "3g":
					abrEstimate = 1500000;
					break;
				case "4g":
					abrEstimate = Math.min(connection.downlink * 1000000 * 0.9, 8000000); // cap at 8 Mbps
					break;
			}
		}
	}

	return abrEstimate;
}

function initializePlayer(video, source) {
	const playerOptions = {
		keyboard: { focused: true, global: true },

		i18n: {
			restart: "Restart",
			rewind: "Převinout zpět {seektime}s",
			play: "Přehrát",
			pause: "Pauza",
			fastForward: "Převinout dopředu {seektime}s",
			seek: "Převinout",
			seekLabel: "{currentTime} z {duration}",
			played: "Přehráno",
			buffered: "Buffered",
			currentTime: "Čas",
			duration: "Doba",
			volume: "Hlasitost",
			mute: "Ztlumit",
			unmute: "Zrušit ztlumení",
			enableCaptions: "Zapnout titulky",
			disableCaptions: "Vypnout titulky",
			download: "Stáhnout",
			enterFullscreen: "Celá obrazovka",
			exitFullscreen: "Ukončit celou obrazovku",
			frameTitle: "Přehrávač pro {title}",
			captions: "Titulky",
			settings: "Nastavení",
			pip: "PIP",
			menuBack: "Zpět",
			speed: "Rychlost přehrávání",
			normal: "Normální",
			quality: "Kvalita",
			loop: "Smyčka",
			start: "Začátek",
			end: "Konec",
			all: "Vše",
			reset: "Reset",
			disabled: "Vypnuto",
			enabled: "Zapnuto",
			advertisement: "Reklama",

			qualityLabel: {
				0: "Automaticky",
			},
		},
	};

	if (video.hasAttribute("muted") && video.getAttribute("muted") != "false") {
		playerOptions.muted = true;
	}
	if (video.hasAttribute("autoplay") && video.getAttribute("autoplay") != "false") {
		playerOptions.autoplay = true;
	}

	if (!Hls.isSupported()) {
		const player = new Plyr(video, playerOptions);
		players.set(video, player);
	}

	// HLS object.
	const hls = new Hls({
		testBandwidth: true,
		abrEwmaDefaultEstimate: estimateBandwidth(),
		autoStartLoad: false,
		maxBufferSize: 20 * 1024 * 1024, // 20MB
		maxBufferLength: 30,
		maxMaxBufferLength: 30,
	});
	hls.loadSource(source);
	hls.attachMedia(video);

	function onUpdateQuality(quality) {
		if (quality == 0) {
			hls.currentLevel = -1; // Enable AUTO quality if option.value = 0
		}
		else {
			hls.levels.forEach((level, levelIndex) => {
				if (level.height == quality) {
					hls.currentLevel = levelIndex;
				}
			});
		}
	}

	video.addEventListener("play", () => hls.startLoad(), { once: true });

	// From the m3u8 playlist, hls parses the manifest and returns
	// all available video qualities. This is important, in this approach,
	// we will have one source on the Plyr player.
	hls.on(Hls.Events.MANIFEST_PARSED, function(event, data) {
		// Transform available levels into an array of integers (height values).
		const availableQualities = hls.levels.map((level) => level.height)
		availableQualities.unshift(0) // Prepend 0 to quality array.

		// Add new qualities to option
		playerOptions.quality = {
			default: availableQualities[0], // Default will be the "AUTO" quality.
			options: availableQualities,
			forced: true,
			onChange: (e) => onUpdateQuality(e),
		}

		// Initialize new Plyr player with quality options
		const player = new Plyr(video, playerOptions);

		// There is probably some race condition in Chrome, so we have to set autoplay again.
		if (playerOptions.muted) {
			player.muted = true;
		}
		if (playerOptions.autoplay) {
			try {
				player.play();
			} catch (e) {
				if (e.name != "NotAllowedError") {
					// Ignore autoplay errors.
					throw e;
				}
			}
		}


		players.set(video, player);
	});

	hls.on(Hls.Events.LEVEL_SWITCHED, function(event, data) {
		var span = document.querySelector(".plyr__menu__container [data-plyr='quality'][value='0'] span")
		if (hls.autoLevelEnabled) {
			span.innerHTML = `AUTO (${hls.levels[data.level].height}p)`
		} else {
			span.innerHTML = `AUTO`
		}
	});

	hlss.set(video, hls);
}

//
// Enable videos
//
onContentReady(function(parent) {
	for (let element of parent.querySelectorAll(".video-player")) {
		const source = element.querySelector("source").getAttribute("src");
		initializePlayer(element, source);
	}
});

document.addEventListener("modal:close", function(event) {
	let modal = event.detail.modal;

	for (let element of modal.querySelectorAll(".video-player")) {
		if (players.has(element)) {
			const player = players.get(element);
			player.destroy();
			players.delete(element);
		}

		if (hlss.has(element)) {
			const hls = hlss.get(element);
			hls.destroy();
			hlss.delete(element);
		}
	}
});
